import * as React from 'react'
import ReactGA from 'react-ga'

import ApplicationRoutes from './ApplicationRoutes'

ReactGA.initialize('UA-68348906-8')
ReactGA.pageview(window.location.pathname + window.location.search)

/**
 * Application layer that handles EVERYTHING
 */
const ApplicationContainer = () => {
  return <ApplicationRoutes />
}

export default ApplicationContainer
